import { render, staticRenderFns } from "./Pace.vue?vue&type=template&id=83e54102&scoped=true"
import script from "./Pace.vue?vue&type=script&lang=js"
export * from "./Pace.vue?vue&type=script&lang=js"
import style0 from "./Pace.vue?vue&type=style&index=0&id=83e54102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e54102",
  null
  
)

export default component.exports